import { useState } from 'react';

const faqs = [
  {
    q: 'Ist EMS-Training sicher?',
    a: 'Ja. EMS ist medizinisch geprüft und wird seit Jahren auch in der Physiotherapie und im Rehasport eingesetzt. Jede Einheit wird individuell auf deinen Körper abgestimmt. Bei bestimmten Einschränkungen – etwa Herzschrittmacher oder Schwangerschaft – ist EMS nicht geeignet. Das klären wir vor dem ersten Termin sorgfältig ab.',
  },
  {
    q: 'Reichen wirklich nur 20 Minuten pro Woche?',
    a: 'Ja – und das ist keine Marketing-Vereinfachung. EMS aktiviert gleichzeitig bis zu 90 % aller Muskelfasern. Physiologisch braucht dein Körper anschließend eine volle Woche zur Regeneration. Mehr wäre nicht sinnvoll – eine Einheit pro Woche ist optimal.',
  },
  {
    q: 'Kann ich ohne Vorkenntnisse starten?',
    a: 'Absolut. Die allermeisten unserer Kunden haben wenig bis keine Trainingserfahrung. Wir starten gemeinsam von Null, passen Intensität und Übungen an dein Niveau an und begleiten dich Schritt für Schritt. Niemand wird hier ins kalte Wasser geworfen.',
  },
  {
    q: 'Was passiert beim ersten Termin – konkret?',
    a: 'Wir lernen uns kennen. Ohne Zeitdruck, ohne Verkaufsgespräch. Wir fragen nach deinen Zielen, deinem Alltag, eventuellen Beschwerden. Dann erklären wir dir EMS verständlich, du legst das Anzugsystem an und wir führen gemeinsam eine erste, sanfte Probeeinheit durch. Der gesamte Termin dauert ca. 45 Minuten.',
  },
  {
    q: 'Muss ich direkt Mitglied werden?',
    a: 'Nein. Das Probetraining ist vollständig kostenlos und ohne jegliche Verpflichtung. Du entscheidest danach frei – ohne Druck, ohne Verkaufsgespräch, ohne Frist. Das ist unser Versprechen.',
  },
  {
    q: 'Was muss ich mitbringen?',
    a: 'Bequeme Funktionskleidung, ein kleines Handtuch, ausreichend Wasser. Den EMS-Anzug stellen wir. Wir empfehlen eine leichte Mahlzeit etwa 1–2 Stunden vorher. Parkplätze sind direkt vor dem Studio vorhanden.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-24 md:py-32" style={{ backgroundColor: '#F4F7F5' }}>
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-14">
          <span
            className="text-xs font-medium tracking-[0.2em] uppercase"
            style={{ fontFamily: 'Inter, sans-serif', color: '#1A5C3D' }}
          >
            Häufige Fragen
          </span>
          <h2
            className="text-3xl md:text-4xl font-bold text-gray-900 mt-4 leading-tight"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Deine Fragen.<br />Unsere ehrlichen Antworten.
          </h2>
          <p
            className="text-gray-500 text-sm mt-4 max-w-md mx-auto leading-relaxed"
            style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
          >
            Keine Werbeversprechen, keine ausweichenden Floskeln.
            Direkte Antworten auf das, was wirklich gefragt wird.
          </p>
        </div>

        <div className="space-y-2.5">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-2xl overflow-hidden transition-all duration-300 border bg-white"
              style={{ borderColor: openIndex === i ? 'rgba(26,92,61,0.25)' : '#e5e7eb' }}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer group"
              >
                <span
                  className="text-gray-800 font-medium text-sm leading-snug pr-4 group-hover:text-gray-900 transition-colors"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  {faq.q}
                </span>
                <div
                  className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-all duration-300 ${openIndex === i ? 'rotate-45' : 'rotate-0'}`}
                  style={{ backgroundColor: openIndex === i ? 'rgba(26,92,61,0.1)' : '#f3f4f6' }}
                >
                  <i
                    className="ri-add-line text-sm"
                    style={{ color: openIndex === i ? '#1A5C3D' : '#9ca3af' }}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-6">
                  <p
                    className="text-gray-500 text-sm leading-relaxed"
                    style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
                  >
                    {faq.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div
          className="mt-12 text-center p-8 bg-white border rounded-3xl"
          style={{ borderColor: 'rgba(26,92,61,0.15)' }}
        >
          <p className="text-gray-600 text-sm leading-relaxed mb-2" style={{ fontFamily: 'Inter, sans-serif' }}>
            Noch eine offene Frage?
          </p>
          <p className="text-gray-900 text-lg font-semibold" style={{ fontFamily: 'Playfair Display, serif' }}>
            Wir antworten persönlich – innerhalb von 24 Stunden.
          </p>
          <button
            onClick={() => {
              const el = document.getElementById('formular');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="mt-5 text-white font-medium text-sm px-7 py-3 rounded-full cursor-pointer whitespace-nowrap transition-all duration-300"
            style={{ backgroundColor: '#1A5C3D', fontFamily: 'Inter, sans-serif' }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#236B48')}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#1A5C3D')}
          >
            Jetzt anfragen →
          </button>
        </div>
      </div>
    </section>
  );
}
